/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Pt } from './Pt';

class CmsCatalog extends Pt {
    constructor() {
        super();
        this.baseUrl += '/cmsCatalog';
    }

    data({ pId, name, isAvailable, schoolOrgId } = {}) {
        return super.get('/data', {
            pId,
            name,
            isAvailable,
            schoolOrgId,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, parentId, name, cmsCatalogType, orderNum, schoolOrgId } = {}) {
        return super.post('/save', {
            id,
            parentId,
            name,
            cmsCatalogType,
            orderNum,
            schoolOrgId,
        });
    }

    delete({ id } = {}) {
        return super.post('/delete', {
            id,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    exists({ id, pId, name, schoolOrgId } = {}) {
        return super.get('/exists', {
            id,
            pId,
            name,
            schoolOrgId,
        });
    }

    selectAll() {
        return super.get(
            '/selectAll',
            {},
            {
                isRepeat: true,
            },
        );
    }

    select({ pId, name } = {}, config) {
        return super.get(
            '/select',
            {
                pId,
                name,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }

    loadSelectNode({ id } = {}, config) {
        return super.get(
            '/loadSelectNode',
            {
                id,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }
}

export default new CmsCatalog();
export { CmsCatalog };
